import {
  CHROMA_COMPOSITE_FAILED,
  CHROMA_COMPOSITE_REQUEST,
  CHROMA_COMPOSITE_SUCCESS,
} from "app/redux/actions/SeriesProduct/ChromaComposite/constant";

const INIT_STATE = {
  loading: false,
  totalPage: 0,
  data: [],
  error: {
    isError: false,
    message: null,
  },
};

export const chromaCompositeReducer = function (state = INIT_STATE, action) {
  switch (action?.type) {
    case CHROMA_COMPOSITE_REQUEST:
      return {
        loading: true,
        totalPage: 0,
        data: [],
        error: {
          isError: false,
          message: null,
        },
      };
    case CHROMA_COMPOSITE_SUCCESS:
      return {
        loading: false,
        data: action?.payload?.data,
        totalPage: action?.payload?.totalPage,
        error: {
          isError: false,
          message: null,
        },
      };
    case CHROMA_COMPOSITE_FAILED:
      const { isError = true, message = "Something Went Wrong" } =
        action?.payload?.error || {};
      return {
        loading: false,
        totalPage: 0,
        data: [],
        error: {
          isError: isError,
          message: message,
        },
      };
    default:
      return state;
  }
};
